import { NgModule } from "@angular/core";

import { LoginComponent } from "./login/login.component";
import { sharedModule } from "src/app/shared/shared.module";
import { accountRouteingModule } from "./account-routing.module";
import { RegisterComponent } from "./register/register.component";
import { AuthComponent } from "src/app/components/auth/auth.component";
import { DemandCodeComponent } from "./login/demand-code/demand-code.component";
import { RegisterFormComponent } from "./register/register-form/register-form.component";
import { ChangePasswordComponent } from "./login/change-password/change-password.component";
import { UserActivationComponent } from "./register/user-activation/user-activation.component";
import { ForgottenPasswordComponent } from "./login/forgotten-password/forgotten-password.component";
import { RegistrationConfirmComponent } from "./register/registration-confirm/registration-confirm.component";
import { RegisterDirectFormComponent } from './register/register-direct-form/register-direct-form.component';
import { AccountsComponent } from './accounts/accounts.component';
import { AccountListComponent } from './accounts/account-list/account-list.component';
import { ChangePassDirectComponent } from './accounts/change-pass-direct/change-pass-direct.component';
import { ProfileEditComponent } from './accounts/profile-edit/profile-edit.component';
import { AccountDetailComponent } from './accounts/account-detail/account-detail.component';
import { AccountSearchComponent } from './accounts/account-search/account-search.component';
import { PayToPersonComponent } from './accounts/pay-to-person/pay-to-person.component';
import { PayToWalletPersonComponent } from './accounts/pay-to-wallet-person/pay-to-wallet-person.component';
import { IosHelpComponent } from './login/ios-help/ios-help.component';
import { SelectHoldingComponent } from './login/select-holding/select-holding.component';

@NgModule({
  declarations: [
    RegisterComponent,
    RegisterFormComponent,
    UserActivationComponent,
    RegistrationConfirmComponent,
    LoginComponent,
    ChangePasswordComponent,
    DemandCodeComponent,
    ForgottenPasswordComponent,
    AuthComponent,
    RegisterDirectFormComponent,
    AccountsComponent,
    AccountListComponent,
    ChangePassDirectComponent,
    ProfileEditComponent,
    AccountDetailComponent,
    AccountSearchComponent,
    PayToPersonComponent,
    PayToWalletPersonComponent,
    IosHelpComponent,
    SelectHoldingComponent
  ],
  entryComponents: [ChangePassDirectComponent, AccountSearchComponent,ProfileEditComponent,AccountDetailComponent, PayToPersonComponent, PayToWalletPersonComponent, IosHelpComponent, SelectHoldingComponent],
  imports: [sharedModule],
  exports: [accountRouteingModule]
})
export class accountModule { }
